export enum NavigationState {
  CLOSED,
  OPEN
}
